'use client';

import React, { useState } from 'react';
import Typography from '@/components/atoms/typography';
import Radio from '@/components/atoms/radio';
import { ShippingMethod } from '@shared/types/cart/ShippingMethod';
import useMediaQuery from '@/hooks/useMediaQuery';
import { desktop } from '@/constants/screensizes';
import EditIcon from './EditIcon';
import Markdown from '@/components/atoms/markdown';
import Accordion from '@/components/molecules/accordion';
import Spinner from '@/components/organisms/spinner';


const DeliveryMethod = ({ selectedShippingMethodName, shippingMethods }: { selectedShippingMethodName: string, shippingMethods: ShippingMethod[] }) => {
    const [isDesktop] = useMediaQuery(desktop);
    const headerFontCss = isDesktop ? 'text-28' : 'text-20';
    const textWrapperCss = isDesktop ? '' : 'mr-10';
    const descriptionCss = isDesktop ? 'text-20 ' : 'text-15';
    const titleCss = isDesktop ? 'text-20 ' : 'text-17';
    const method = shippingMethods.find((s) => s.name === selectedShippingMethodName) || shippingMethods?.[0];
    const [isNavigating, setIsNavigating] = useState(false);
    return <>
        {isNavigating && <Spinner />}

        {isNavigating && (
            <div className="overlay fixed left-0 top-0 z-50 h-full w-full bg-gray-800 opacity-75"></div>
        )}
        <div className='mt-4 bg-[#FFFFFF] p-4' id="delivery-method">
            <h3 className={`${headerFontCss} font-semibold`}>2. Delivery Method</h3>
            <div className='border min-h-[80px] !border-[black] md:!border-[#D7D7D7]   rounded-md p-2 pt-4 pb-4 mt-4 h-auto w-full flex justify-between relative'>
                <div style={{ marginRight: 'min(25%, 64px)' }} className={`flex ${textWrapperCss} lg:w-[70%] `}>
                    {/* <div className="flex items-center"> */}
                        <Accordion.Button withArrow={false} className="items-center justify-center cursor-pointer no-arrow flex-shrink-0 !w-[39px]">
                          <Radio
                            className="m-1 !h-[27px] !w-[27px] !accent-black"
                            checked={true}
                            readOnly
                          />
                        </Accordion.Button>
                    {/* </div> */}
                    <div className="flex flex-col lg:!ml-[41px] lg:mt-0 gap-2 w-full">
                        <div className="">
                            <Typography className={`${titleCss} !leading-6 text-[17px] md:!text-[20px] !font-medium`}>{method?.name}</Typography>
                        </div>
                        <div className="text-[15.5px] lg:!text-[20px] !font-light lg:!sr-onlytext-[20px]">
                            <Markdown>{method?.description}</Markdown>
                        </div>
                    </div>
                </div>
                <EditIcon className='m-2  lg:w-[20%]  2xl:w-auto absolute right-2 top' location='/checkout/#delivery-method' onClick={() => setIsNavigating(true)} />
            </div>
            {isDesktop && <div className='mt-10'>
                <hr className="border-t-2 border-[#EFF0F2]" />
            </div>}
        </div>
    </>
};

export default DeliveryMethod;


